import { Truck, BadgeCheck, Handshake } from 'lucide-react';
import { SectionTitle } from '@atoms/SectionTitle';

const PROPS = [
  {
    icon: Truck,
    title: 'Hızlı Tedarik',
    description: 'Bölgenizdeki toptancılardan doğrudan sipariş verin. Tedarik sürecinizi dijitalleştirin.',
  },
  {
    icon: BadgeCheck,
    title: 'Şeffaf Fiyat',
    description: 'Net birim fiyatları, kampanya koşullarını ve sipariş geçmişinizi tek platformda takip edin.',
  },
  {
    icon: Handshake,
    title: 'Güvenilir Partner',
    description: 'Doğrulanmış toptancılar, değerlendirme sistemi ve kurumsal destek altyapısı.',
  },
];

export function ValuePropsSection() {
  return (
    <section className="section-container py-16 md:py-20">
      <SectionTitle
        title="Neden Lezzet Yolda "
        accent="Toptan?"
        subtitle="Restoran işletmeleri için tasarlanmış profesyonel B2B tedarik deneyimi."
      />
      <div className="grid gap-6 md:grid-cols-3">
        {PROPS.map((prop) => {
          const Icon = prop.icon;
          return (
            <div key={prop.title} className="card-elevated p-6 md:p-8">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-50">
                <Icon className="h-5 w-5 text-brand-600" strokeWidth={1.75} />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-slate-900">{prop.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{prop.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
